import '../node_modules/core-js/modules/es.array.reduce.js';
import '../node_modules/core-js/modules/web.dom-collections.iterator.js';
import '../node_modules/core-js/modules/es.promise.constructor.js';
import '../node_modules/core-js/modules/es.promise.all.js';
import '../node_modules/core-js/modules/es.promise.catch.js';
import '../node_modules/core-js/modules/es.promise.race.js';
import '../node_modules/core-js/modules/es.promise.reject.js';
import '../node_modules/core-js/modules/es.promise.resolve.js';
import '../node_modules/core-js/modules/es.regexp.to-string.js';

/**
 * This function checks if 'something' is string;
 * @param something
 */
function isString(something) {
  return typeof something === 'string';
}

/**
 * This is a function, which performs no operation and once invoked it returns undefined.
 */
function noop() {
  return undefined;
}

/**
 * This function rounds up the value in the loop so that it fits within the passed range
 * @param index
 * @param range
 */
function limitIndexToRange(index, range) {
  const remainder = index % range || 0;
  if (index < 0) {
    return remainder + range;
  }
  return remainder;
}

export { isString, limitIndexToRange, noop };
